import type { Aggregations, ReferenceData } from '@cinch-nx/data-search'
import { options } from '../formatter-options'

type AggreagationValues = Aggregations[keyof Aggregations]

function getFacetCount(facetData: AggreagationValues, item: ReferenceData) {
  const facetCounts = facetData as Record<string, number>
  let aliasCount = 0
  if (item.facetKeys) {
    /* If the item has aliases/synonyms e.g:
      {
        label: 'Automatic',
        value: 'automatic',
        facetKeys: ['semi-auto', 'automatic'],
      }
      The the total count will be its main value (item.value) and all
      the counts of the aliases (item.faceKeys). However if the facetKey
      array contains the value, then we filter that to prevent counting
      the main value twice
    */
    aliasCount = item.facetKeys
      .filter((aliasValue) => aliasValue !== item.value)
      .reduce(
        (accumilatorCount, aliasValue) =>
          accumilatorCount + (facetCounts[aliasValue] ?? 0),
        0,
      )
  }
  const facetCount = facetCounts[item.value] ?? 0

  return facetCount + aliasCount
}

export function formatFilterOptionValue(
  key: keyof Aggregations,
  referenceData: ReferenceData[],
) {
  const currentFacet = options.facets?.[key]

  if (!currentFacet) return []

  return referenceData.map((item: ReferenceData) => ({
    ...item,
    doc_count: getFacetCount(currentFacet, item),
  }))
}
